import { Input, Card } from "antd";

import DeadParkingTable from "./Table/DeadParkingTable";
import styles from "../MasterManagement/index.module.less";

const DeadParkingUpdate = () => {
  return (
    <Card
      className="gx-card card--height"
      title={
        <div className={styles["head-container"]}>
          <div className={styles["title-container"]}>
            <span>Dead Parking Update</span>
          </div>
          <div className={`${styles["extra-container"]}`}>
            <Input.Search className={`gx-mb-0 search-component__width ${styles["input-search"]}`} allowClear placeholder={`Search...`} />
          </div>
        </div>
      }
    >
      <DeadParkingTable />
    </Card>
  );
};
export default DeadParkingUpdate;
